export const ONE_SECOND = 1000;
export const THIRTY_SECONDS = 30 * ONE_SECOND;
export const ANNOUNCEMENT_DELAY = 20;